import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import { dedupeGet } from "./dedupe.js";

Vue.use(Vuex);

// https://www.npmjs.com/package/vue-scrollto
var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

// Only good for <input> tags
Vue.directive("uppercase", {
  update(el) {
    el.value = el.value.toUpperCase();
  },
});

// const baseUrl = 'http://local.taptags.com:3000/';
import { fetcher } from "@/fetcher";
//const baseUrl = process.env.VUE_APP_TAPTAGS_API_URL;
//const fetcher = axios.create({baseURL: baseUrl, withCredentials: true});

export default new Vuex.Store({
  state: {
    foo: 1,
    myprofile: {},
    current_event_id: 0,
    events: [],
    event_products: [],
    event_orders: [],
    event_teams: [],
    event_sales_channels: [],
    event_options_pending: [],
    event_options_confirmed: [],
    attendees: undefined,
  },
  mutations: {
    setCurrentEvent(state, attrs) {
      state.current_event_id = attrs.event_id;
    },
    setEvents(state, attrs) {
      state.events = [...attrs.events];
    },
    setEventProducts(state, attrs) {
      state.event_products = [...attrs.products];
    },
    resolveEventOptions(state, attrs) {
      let next_event_options_pending = [];
      let next_event_options_confirmed = [];

      // Determine pending or confirmed options
      state.event_orders.forEach((o) => {
        o.order_items.forEach((oi) => {
          let oi_options = oi.product.options
            .split(",")
            .filter((po) => po != "");

          if (o.canceled_at || o.refunded_at) {
            console.log(o, oi, "CR");
          } else if (o.paid_at || o.processed_at) {
            // ignore, need to check tickets since they may have been transferred out after processing
            //next_event_options_confirmed.push(oi_options);
          } else {
            // whether submitted_at or wait list, the option is pending
            next_event_options_pending.push(oi_options);
          }
        });
      });

      let current_attendee = state.attendees.find(
        (a) => a.event_id == state.current_event_id
      );
      if (current_attendee) {
        current_attendee.tickets
          .filter((t) => !t.canceled_at)
          .forEach((t) => {
            let teo_options = t.ticket_event_options.map((teo) => teo.code);
            next_event_options_confirmed.push(teo_options);
          });
      }

      // convert [[a,b],[a,b]] to [a,b]
      state.event_options_pending = [
        ...new Set(next_event_options_pending.flat()),
      ];
      state.event_options_confirmed = [
        ...new Set(next_event_options_confirmed.flat()),
      ];
    },
    setEventOrders(state, attrs) {
      state.event_orders = [...attrs.orders];
    },
    setEventTeams(state, attrs) {
      state.event_teams = [...attrs.teams];
    },
    setEventSalesChannels(state, attrs) {
      state.event_sales_channels = [...attrs.sales_channels];
    },
    setProfile(state, attrs) {
      state.myprofile = Object.assign({}, attrs);
    },
    setAttendees(state, attrs) {
      console.log("sA in", state, attrs);
      state.attendees = [...attrs.attendees];
    },
    doCleanHouse(state, attrs) {
      state.attendees = [];
      state.events = [];
      state.myprofile = {};
    },
  },
  actions: {
    loadEvents({ commit, state, dispatch }, attrs) {
      var getUrl = `/myprofile/events`;
      return fetcher.get(getUrl).then((response) => {
        commit("setEvents", response.data);
        return response;
      });
    },
    loadEventProducts({ commit, state, dispatch }, attrs) {
      return fetcher
        .get("/myprofile/event_products", {
          params: { event_id: attrs.event_id },
        })
        .then((response) => {
          commit("setEventProducts", response.data);
          return response;
        });
    },
    loadEventOrders({ commit, state, dispatch }, attrs) {
      return fetcher
        .get("/myprofile/event_orders", {
          params: { event_id: attrs.event_id },
        })
        .then((response) => {
          commit("setCurrentEvent", { event_id: attrs.event_id });
          commit("setEventOrders", response.data);
          commit("resolveEventOptions");
          return response;
        });
    },
    loadEventTeams({ commit, state, dispatch }, attrs) {
      return fetcher
        .get("/myprofile/event_teams", { params: { event_id: attrs.event_id } })
        .then((response) => {
          commit("setEventTeams", response.data);
          return response;
        });
    },
    loadEventSalesChannels({ commit, state, dispatch }, attrs) {
      return fetcher
        .get("/myprofile/event_sales_channels", {
          params: { event_id: attrs.event_id },
        })
        .then((response) => {
          commit("setEventSalesChannels", response.data);
          return response;
        });
    },
    loadAttendees({ commit, state, dispatch }, attrs) {
      return fetcher.get("/myprofile/attendees").then((response) => {
        commit("setAttendees", response.data);
        commit("resolveEventOptions");
        return response;
      });

      /*
      console.log('loadAttendees');
      let getUrl = '/myprofile/attendees';
      if (dedupeGet(getUrl, 1000)) {
        return fetcher.get('/myprofile/attendees').then(response => {
          console.log('setAttendees', response.data);
          commit('setAttendees', response.data);
          return response;
        });
      } else {
        return Promise.resolve(true);
      }
      */
    },
    updateAttendee({ commit, state, dispatch }, attrs) {
      return fetcher
        .put("/myprofile/update_attendee", {
          attendee: attrs.attendee,
          attendee_event_meta: attrs.attendee_event_meta,
        })
        .then((response) => {
          dispatch("loadAttendees");
          return response;
        });
    },
    forceProfile({ commit, state, dispatch }, attrs) {
      commit("setProfile", attrs.data);
    },
    loadProfile({ commit, state, dispatch }, attrs) {
      return fetcher.get("/myprofile/check_session").then((response) => {
        commit("setProfile", response.data);
        return response;
      });
    },
    updateProfile({ commit, state, dispatch }, attrs) {
      return fetcher
        .put("/myprofile/update", { profile: attrs.data })
        .then((response) => {
          commit("setProfile", response.data);
          return response;
        });
    },
    verifyPaypalPayment: async function({ commit, state, dispatch }, attrs) {
      // attrs = { order_id: pp_order_id, paypal_order_id: data.orderID }
      await fetcher.post("/myprofile/process_paypal_callback", {
        event_id: attrs.event_id,
        paypal_order_id: attrs.paypal_order_id,
      });

      dispatch("loadEventOrders", {
        event_id: attrs.event_id,
      });
      return true;
    },
    cleanHouse({ commit, state, dispatch }, attrs) {
      commit("doCleanHouse");
    },
  },
});
